import { FunctionComponent } from 'react'
import { rucksack, Box } from '@black-bear-energy/rucksack'

export const SiteInfoBox: FunctionComponent<SiteInfoBoxProps> = ({
  children,
  flexDirection = 'row',
}) => {
  return (
    <Box
      sx={{
        padding: 2,
        display: 'flex',
        flexDirection,
        justifyContent: 'space-between',
        flex: 1,
        border: '1px solid',
        borderColor: rucksack.palette.primary.outlinedBorder,
        borderRadius: rucksack.shape.borderRadius,
      }}
    >
      {children}
    </Box>
  )
}

interface SiteInfoBoxProps {
  children: React.ReactNode
  flexDirection?: 'row' | 'column'
}
